import React from 'react'
import { getIn, FormikErrors } from 'formik'
import { PreviewOptions, IEditionMetadataInput } from '../../types/pack'
import { IPackInput } from '../../types/pack'
import { SetPreviewFieldWrapperType } from '../../types/file'
import { getNewTmpPreview } from '../../services/file'
import { getPreviewImages } from '../../services/pack'
import {
  H3,
  CustomRadioGroup,
  PreviewPicture,
  PreviewUploadZone,
} from '../../components'
import { StyledRadioGroup } from './styled'
import { editionPreviewValidate } from './validation'

export interface IEditionPreviewFormFragment {
  index: number
  edition: IEditionMetadataInput
  packThumbnailURI?: string
  setPreviewFieldWrapper: SetPreviewFieldWrapperType
  isFormDisabled?: boolean
  errors: FormikErrors<IPackInput>
}

export const EditionPreviewFormFragment = ({
  index,
  edition,
  packThumbnailURI,
  setPreviewFieldWrapper,
  isFormDisabled,
  errors,
}: IEditionPreviewFormFragment): JSX.Element => {
  const { thumbnailURI } = getPreviewImages(edition)
  const previewSrc =
    edition.useGraphicPreview === PreviewOptions.useGraphicPreview ||
    !thumbnailURI
      ? packThumbnailURI
      : thumbnailURI
  const newTmpPreview = getNewTmpPreview(edition)
  const previewError = getIn(errors, `editions.${index}.useGraphicPreview`)
  return (
    <StyledRadioGroup>
      <legend>
        <H3>Preview</H3>
      </legend>
      <div>
        <section>
          <CustomRadioGroup
            name={`editions.${index}.useGraphicPreview`}
            disabled={isFormDisabled}
            items={[
              {
                value: PreviewOptions.useGraphicPreview,
                label: 'Use pack preview',
              },
              ...(!!thumbnailURI
                ? [
                    {
                      value: PreviewOptions.useFilePreview,
                      label: 'Use file preview',
                    },
                  ]
                : []),
              {
                label: 'Upload new file preview',
                value: PreviewOptions.useUploadedPreview,
              },
            ]}
            index={index}
            validate={editionPreviewValidate(edition)}
            error={previewError}
          />
          {edition.useGraphicPreview === PreviewOptions.useUploadedPreview && (
            <PreviewUploadZone
              id={`preview-input-${edition.id}`}
              setPreviewFieldWrapper={setPreviewFieldWrapper}
            />
          )}
        </section>
        <picture>
          <PreviewPicture
            width="250px"
            height="250px"
            size="250px"
            src={newTmpPreview || previewSrc}
          />
        </picture>
      </div>
    </StyledRadioGroup>
  )
}
